import { gql } from '@apollo/client';

export default gql`
  mutation CancelScheduledSystemAction($id: Int!, $reason: String!) {
    cancelScheduledSystemAction(id: $id, reason: $reason) {
      success
      message
      log_entry {
        id
        process_status
        cancelled_at
        cancel_reason
      }
    }
  }
`;
